import React, { useState, useEffect } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate, useParams } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import axios from "axios";
import { setTime } from "react-datepicker/dist/date_utils";
import { getSpecificTeri, updateTeri, getDropdowns } from "../api/territory";
import SearchableDropdown from "../../zamzam/components/SearchableDropdown";

const EditTerritory = () => {
  const [formData, setFormData] = useState({
    id: "",
    emp_id: "",
    territory_identifier: "",
    // session_entity_key: "",
    // territory_entity_key: "",
  });
  const [values, setValues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [addressError, setAddressError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleAddressSelectChange = (event: React.ChangeEvent<HTMLSelectElement> | null) => {
    if (event && event.target.value) {
      setFormData((prev) => ({ ...prev, territory_identifier: event.target.value }));
      setAddressError(false);
    } else {
      setFormData((prev) => ({ ...prev, territory_identifier: "" }));
    }
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${invalidFields.includes(field) ? "border-red-500" : ""}`;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const paramsObj = {
      emp_id: formData.emp_id,
      territory_identifier: formData.territory_identifier,
      // session_entity_key: formData.session_entity_key,
      // territory_entity_key: formData.territory_entity_key,
    };

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([key]) => key);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }

      const response = await updateTeri(formData, formData.id);
      if (!response) {
        console.warn("Invalid or empty response:", response);
        toast.error("Invalid or empty response");
        return;
      }
      toast.success("Territory updated successfully!");
      setTimeout(() => {
        navigate(URL_MAPPING.TERRITORY);
      }, 2000);
    } catch (error: any) {
      console.error("Error fetching territory data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the territory", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) =>
            toast.error(err.msg, {
              autoClose: false,
              closeOnClick: true,
              draggable: true,
            })
          );
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.", {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchMappings = async () => {
      try {
        const res = await getDropdowns();
        if (!res) {
          toast.error("No data received or malformed response");
          console.warn("No data received or malformed response:", res);
          return;
        }
        // Adapt values to expected format for SearchableDropdown
        setValues(
          (res || []).map((v: string, idx: number) => ({
            id: String(idx),
            name: v,
            outlet_id: v,
          }))
        );
      } catch (error: any) {
        console.error("Failed to fetch employee data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(detail?.msg || detail || "An unexpected error occurred.");
          }
        }
      } finally {
        setLoading(false);
      }
    };
    fetchMappings();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSpecificTeri(id as string);
        if (!response) {
          console.warn("Invalid or empty  response:", response);
          toast.error("Invalid or empty  response");
          return;
        }
        const data = response;
        setFormData({
          id: data.id,
          emp_id: data.emp_id || "",
          territory_identifier: data.territory_identifier || "",
          // session_entity_key: data.session_entity_key || "",
          // territory_entity_key: data.territory_entity_key || "",
        });
      } catch (error: any) {
        console.error("Error fetching customer data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(detail?.msg || detail || "An unexpected error occurred.");
          }
        }
      }
    };
    fetchData();
  }, []);

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Edit Territory</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Territory ID</label>
          <input name="id" disabled value={formData.id} />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Employee ID </label>
          <input
            type="text"
            name="emp_id"
            disabled
            value={formData.emp_id}
            onChange={() => {}}
            className={getInputClass("emp_id")}
            placeholder="Employee Id"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Select Territory_identifier *</label>
          <SearchableDropdown
            addressOptions={values}
            selectedAddress={formData.territory_identifier}
            handleAddressSelectChange={handleAddressSelectChange}
            loading={loading}
            error={null}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            addressError={invalidFields.includes("territory_identifier")}
            setAddressError={setAddressError}
            label={false}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Update Territory {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default EditTerritory;
